import React, { useEffect } from 'react';
import {
  getToolsArrayAndLength,
  removeDefaultParams,
} from '../../../Utils/helper';
import {
  CardSection,
  CardTitle,
} from '../../ArticlePage/RelatedArticlesNew/styled';
import { PopularToolsList, ToolsName, ToolsRoundCorner } from './styled';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { getPublicUrl } from '../../../appconfig';
import { fireServedSectionEvent } from '../../../Utils/useFirebase';

export default function PopularTools(props) {
  const { toolsData } = props;
  const router = useRouter();

  const { toolsarray, toolsLength } = getToolsArrayAndLength(toolsData?.data);
  useEffect(() => {
    if (toolsarray) {
      let cardIds = '';
      toolsarray?.map((element, index) => {
        let id = element?.id;
        index == 0 ? (cardIds = id) : (cardIds = cardIds + ',' + id);
      });
      cardIds = cardIds.slice(0, 98);
      fireServedSectionEvent('Popular Tools', cardIds, 'topic');
    }
  }, []);

  const toolsClickHandler = (item) => {
    if (item.id == 13) {
      window.location.href = `${getPublicUrl()}/store/babyexpendeture${
        window.location.search
      }`;
    } else if (item && item?.value != null) {
      window.location.href =
        getPublicUrl() + item?.value + window.location.search;
    }
  };

  return (
    <CardSection popularTools>
      <CardTitle>Popular Tools</CardTitle>
      <PopularToolsList>
        {toolsarray.slice(0, 5)?.map((element, index) => {
          return (
            <li
              onClick={() => toolsClickHandler(element)}
              key={`tools_${index}`}
            >
              <ToolsRoundCorner>
                <img src={element.image} alt="" />
              </ToolsRoundCorner>

              <ToolsName>{element.name}</ToolsName>
            </li>
          );
        })}
        <Link
          href={{
            pathname: '/tools',
            query: removeDefaultParams(router.query),
          }}
          locale={false}
          passHref
        >
          <li>
            <ToolsRoundCorner>
              <p className="total_tools">+{toolsLength}</p>
            </ToolsRoundCorner>
            <ToolsName>View All Tools</ToolsName>
          </li>
        </Link>
      </PopularToolsList>
    </CardSection>
  );
}
